<template>
  <b-overlay
    variant="light"
    :show="loading"
    spinner-variant="primary"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <b-card>
      <div class="flex items-start">
        <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 w-full mb-2">
          <div class="flex">
            <b-button
              variant="primary"
              size="sm"
              class="mr-1 rounded-lg p-0 h-[30px]"
              @click="goBack()"
            >
              <feather-icon
                size="2x"
                icon="ChevronLeftIcon"
              />
            </b-button>
            <div class="text-black text-2xl font-semibold">
              Detail Pengajuan Packing
            </div>
          </div>
          <div>
            <CancelOrderButton
              ref="cancelBtn"
              :status="data.status"
              @cancel="cancelPacking"
            />
          </div>
        </div>
      </div>
      <div class="border rounded-[12px] p-6 space-y-6">
        <div class="grid grid-cols-1 md:grid-cols-3 !gap-5 text-black">
          <div class="">
            <div class="mb-[12px] text-lg font-medium">
              Tanggal Order
            </div>
            <div class="text-[#626262]">
              {{ orderDate }}
            </div>
            <div class="text-sm text-[#828282] !capitalize">
              {{ orderTime }}
            </div>
          </div>
          <div class="">
            <div class="mb-[12px] text-lg font-medium">
              Gudang
            </div>
            <div class="text-[#626262]">
              {{ warehouse.name }}
            </div>
            <div class="text-sm text-[#828282] !capitalize">
              {{ warehouse.location }}
            </div>
          </div>
          <div class="">
            <div class="mb-[12px] text-lg font-medium">
              Label Pengiriman
            </div>
            <div
              v-if="!loading"
              class="d-flex justify-content-between items-center gap-[5px]"
            >
              <div class="flex gap-[5px]">
                <b-img
                  :src="label_name ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/document-text.svg' : 'https://storage.googleapis.com/komerce/icon/error_file.svg'"
                  width="24"
                  height="24"
                  alt="label"
                />
                <b-link
                  class="underline !text-[#626262]"
                  :href="label_url"
                  target="_blank"
                >{{ label_name || "File Error" }}
                </b-link>
                <b-form-file
                  ref="label_ref"
                  v-model="label_file"
                  accept="application/pdf"
                  class="mt-3"
                  plain
                  hidden="true"
                />
              </div>
              <b-button
                v-if="!label_name"
                variant="primary"
                size="sm"
                @click="$refs.label_ref.$el.click()"
              ><i class="k-export-2 mr-[10px]" /><span>Reupload</span></b-button>
              <b-button
                v-if="label_file"
                variant="primary"
                size="sm"
                class="d-flex items-center"
                @click="uploadLabel"
              ><b-spinner
                v-if="reupload_inprogress"
                small
              /><span class="ml-[5px]">{{ reupload_inprogress ? "Menyimpan..." : "Simpan" }}</span></b-button>
            </div>
            <div
              v-else
              class="text-[#626262]"
            >
              -
            </div>
          </div>
        </div>
      </div>
      <div class="mt-6 space-y-6">
        <div class="text-black">
          Rangkuman Order
        </div>

        <Table
          ref="orderTable"
          :items="data.order_summary"
          :grand-total-order="grandTotalOrder"
          :batch-status="data.status"
          @update-selected="onSelectedChange"
        />

        <div class="text-black space-y-2 !py-[20px]">
          <b-row align-h="end">
            <b-col cols="2">
              Total Order
            </b-col>
            <b-col cols="0">
              :
            </b-col>
            <b-col cols="2">
              <span>
                {{ grandTotalOrder }}
              </span>
            </b-col>
          </b-row>
          <b-row align-h="end">
            <b-col cols="2">
              Total Biaya
            </b-col>
            <b-col cols="0">
              :
            </b-col>
            <b-col cols="2">
              <span>
                {{ grand_fulfillment_fee | rupiah }}
              </span>
            </b-col>
          </b-row>
        </div>
      </div>

      <ModalConfirm
        ref="modalConfirm"
      />
    </b-card>
  </b-overlay>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { toast_error, toast_success } from '@/libs/toastification'
import filters from '@/libs/filters'
import Table from './components/Table.vue'
import ModalConfirm from './components/ModalConfirm.vue'
import CancelOrderButton from './components/CancelOrderButton.vue'

export default {
  components: {
    Table,
    ModalConfirm,
    CancelOrderButton,
  },
  filters: { rupiah: filters.rupiah },
  props: {
    detailId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: {},
      refId: this.$route.query.ref_id,
      label_file: null,
      loading: false,
      items: [],
      status: '',
      label_url: '',
      label_name: '',
      grand_total_order: 0,
      grand_fulfillment_fee: 0,
      warehouse: {
        name: '-',
        location: '-',
      },
      reupload_inprogress: false,
    }
  },
  computed: {
    grandTotalOrder() {
      return this.data.order_summary?.reduce((acc, item) => (item.status !== 'Dibatalkan' ? acc + item.total_order : acc), 0) || 0
    },
    totalOrderUnprocessed() {
      return this.data.order_summary?.reduce((acc, item) => (item.status !== 'Dibatalkan' ? acc + 1 : acc), 0) || 0
    },
    outboundId() {
      return this.data.id ? this.data.id : (this.refId || this.detailId)
    },
    orderDate() {
      const date = new Date(this.data.created_at)
      return date.toLocaleDateString('id-ID', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    },
    orderTime() {
      const date = new Date(this.data.created_at)
      return date.toLocaleTimeString('id-ID', {
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
  watch: {
    label_file(new_value) {
      if (new_value.name) this.label_name = new_value.name
      this.label_url = URL.createObjectURL(new_value)
    },
  },
  created() {
    this.selectedItems = []
  },
  mounted() {
    this.fetchDetailPacking()
  },
  beforeDestroy() {
    this.data = {}
  },
  methods: {
    onSelectedChange(selected) {
      this.selectedItems = selected
      if (this.$refs.cancelBtn) {
        this.$refs.cancelBtn.setCancelable(selected.length > 0)
      }
    },
    /**
     * Reuploads the label file to the server and handles the upload process.
     */
    uploadLabel() {
      this.reupload_inprogress = true
      const formData = new FormData()
      formData.append('label', this.label_file)

      newAxiosIns
        .put(`/kompack/api/v1/outbounds/label/${this.outboundId}`, formData)
        .then(() => {
          toast_success({
            title: 'Berhasil!',
            message: 'Label pengiriman berhasil diunggah.',
          })
          this.label_file = null
          this.fetchDetailPacking()
          this.selectedItems = []
        })
        .catch(() => {
          toast_error({
            title: 'Gagal!',
            message: 'Terjadi kesalahan, file kamu gagal diunggah. Coba lagi nanti.',
          })
          this.label_name = null
          this.label_file = null
        })
        .finally(() => {
          this.reupload_inprogress = false
        })
    },
    async fetchDetailPacking() {
      this.loading = true
      await newAxiosIns
        .get(
          `/kompack/api/v1/outbounds/${this.refId}`,
        )
        .then(res => {
          const { data } = res.data

          this.data = data

          this.label_url = data.label_url
          this.label_name = data.label_name
          this.grand_fulfillment_fee = data.grand_fulfillment_fee
          this.warehouse.name = data.warehouse_name
          this.warehouse.location = data.warehouse_location.toLowerCase()

          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$toast_error({ message: 'Terjadi kesalahan, silakan coba lagi.' })
        })
    },
    /**
     * Shows the modal confirmation for canceling the packing.
     */
    cancelPacking() {
      this.$refs.modalConfirm.show({
        title: 'Batalkan Order',
        description: 'Order yang dibatalkan tidak bisa diproses Mitra Gudang. Yakin batalkan order?',
        type: 'confirm',
        confirmFn: async () => {
          await this.processPackingCancelation()
        },
      })
    },
    /**
     * Shows the success confirmation for packing cancelation.
     */
    packingCancelationSuccess() {
      const description = this.data.status === 'Belum Dipacking'
        ? 'Order berhasil dibatalkan. Biaya Fulfillment akan direfund 100% ke Saldo Kompay kamu.'
        : 'Order berhasil dibatalkan. Biaya Penyimpanan dan Biaya Teknologi akan direfund ke Saldo Kompay kamu.'

      this.$refs.modalConfirm.show({
        title: 'Berhasil Dibatalkan',
        description,
        type: 'success',
      })

      this.fetchDetailPacking()
    },
    /**
     * Processes the packing cancelation for the selected items.
     */
    async processPackingCancelation() {
      if (!this.selectedItems.length) return

      this.$refs.cancelBtn.setLoading(true)

      const payload = {
        cancel_all: this.selectedItems.length === this.totalOrderUnprocessed,
        outbound_detail_ids: this.selectedItems.map(item => this.data.order_summary[item].outbound_detail_id),
      }

      try {
        await this.$http_new.put(`/kompack/api/v1/outbounds/${this.outboundId}/cancel`, payload)

        this.packingCancelationSuccess()
      } catch (error) {
        this.$toast_error({ message: 'Pembatalan pengajuan gagal. Silakan coba lagi.' })
      } finally {
        this.loading = false
        this.$refs.cancelBtn.setLoading(false)
      }
    },
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'history-pickup', query: { type: 'non-komship' } })
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>
